// TB Corporate Orders nav panel — honeypot handling (2026-07-13)
// Additive, new asset file. Self-contained; does not touch any other script.
// Native Shopify `contact` form has no built-in spam filtering, so this is a client-side
// bot-trap: if the decoy field (#tb-corp-nav-hp, hidden via CSS in tb-corp-nav-panel.append.css)
// has a value at submit time, silently no-op the real POST and show the same success copy
// a real submitter would see (classic honeypot behavior — don't tip off the bot).
(function () {
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.id !== 'tb-corp-nav-form') return;
    var hp = form.querySelector('#tb-corp-nav-hp');
    if (hp && hp.value.trim() !== '') {
      e.preventDefault();
      var successEl = form.querySelector('.tb-corp-form-success');
      if (!successEl) {
        successEl = document.createElement('p');
        successEl.className = 'tb-corp-form-success';
        successEl.setAttribute('role', 'status');
        successEl.textContent = 'Thanks — a real person from our team will reply within 1 business day.';
        form.appendChild(successEl);
      }
      form.reset();
    }
  }, true);
})();
